// extracted by mini-css-extract-plugin
module.exports = {"footor_content":"Footer_footor_content__1Cb64"};